import {
  next,
  start,
} from '@/api/gen/quizset-folder-controller/quizset-folder-controller.gen';

export const startFolderPlay = async (id: string, language: string) =>
  (await start(id, { language })).data;

export const fetchNextFolderQuiz = async (
  id: string,
  currentQuizsetId: string,
) => (await next(id, { quizsetFolderId: id, currentQuizsetId })).data;
